// Set a product image as primary
export function setPrimaryImage(productId, imageId) {
    const csrfToken = (document.cookie.match(/csrftoken=([^;]+)/) || [])[1] || '';
    return fetch(`/api/v1/products/${productId}/set-primary-image/${imageId}/`, {
        method: 'POST',
        headers: {
            'X-CSRFToken': csrfToken,
        },
        credentials: 'include',
    }).then(async (res) => {
        if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.detail || err.message || 'Failed to set primary image');
        }
        return res.json();
    });
}
// Upload an image to the generic image API
export function uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    // Get CSRF token from cookie
    const csrfToken = (document.cookie.match(/csrftoken=([^;]+)/) || [])[1] || '';
    return fetch('/api/v1/images/', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'X-CSRFToken': csrfToken,
        },
        body: formData,
    }).then(async (res) => {
        if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.detail || err.message || 'Failed to upload image');
        }
        return res.json();
    });
}
// Associate an image with a product (PATCH product or create ProductImage)
export function associateImageWithProduct(productId, imageId) {
    // PATCH product with image_id (if model supports it)
    return fetch(`/api/v1/products/${productId}/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': (document.cookie.match(/csrftoken=([^;]+)/) || [])[1] || '',
        },
        credentials: 'include',
        body: JSON.stringify({ image_id: imageId }),
    }).then(async (res) => {
        if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.detail || err.message || 'Failed to associate image');
        }
        return res.json();
    });
}
import request from '../utils/request';
// Get all products with optional filters
export function getProducts(filters) {
    const params = new URLSearchParams();
    if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
            if (value === undefined || value === null) {
                return;
            }
            if (typeof value === 'string') {
                const normalizedValue = key === 'search' ? value.trim() : value;
                if (normalizedValue !== '') {
                    params.append(key, normalizedValue);
                }
                return;
            }
            if (value !== '') {
                params.append(key, value.toString());
            }
        });
    }
    const queryString = params.toString();
    const url = queryString ? `/api/v1/products/?${queryString}` : '/api/v1/products/';
    return request().get(url).send();
}
// Get a single product by ID
export function getProduct(id) {
    return request().get(`/api/v1/products/${id}/`).send();
}
// Get featured products
export function getFeaturedProducts() {
    return request().get('/api/v1/products/featured/').send();
}
// Get available categories
export function getProductCategories() {
    return request().get('/api/v1/products/categories/').send();
}
// Get product by path (for detail pages)
export function getProductByPath(path) {
    return request()
        .get(`/api/v1/products/?path=${encodeURIComponent(path)}`)
        .send();
}
